import { I18n } from '@aws-amplify/core';

import type { BeraReportSegmentDTO } from '@/components/views/BeraJob/hooks/types/response';
import { fromSegmentTime } from '@/components/views/BeraJob/BeraReportV2/utils';

export const FIRST_PAGE = 1;
export const REPORTS_PER_PAGE = 10;

export const STRETCH_FILTER = {
	ALL: 'all',
	NOT_EVALUATED: 'not-evaluated',
	OUT_OF_VIDEO: 'out-of-video'
} as const;

export type StretchFilter = (typeof STRETCH_FILTER)[keyof typeof STRETCH_FILTER];

export function buildRangeLabel(total: number, page: number): string {
	const first = page * REPORTS_PER_PAGE + FIRST_PAGE;
	const last = Math.min(first + REPORTS_PER_PAGE - FIRST_PAGE, total);
	const result = `${I18n.get('Displaying')} ${first}-${last} ${I18n.get('of')} ${total}`;

	return result;
}

const SINGLE_STRETCH = 1;
const STRETCH_LABEL_TIME_FORMAT = 'HH:mm:ss';

function toStretchIntervalLabel(segment: BeraReportSegmentDTO): string {
	const start = fromSegmentTime(segment.segment_start).format(STRETCH_LABEL_TIME_FORMAT);
	const end = fromSegmentTime(segment.segment_end).format(STRETCH_LABEL_TIME_FORMAT);
	const result = `${start} - ${end}`;

	return result;
}

export function buildStretchesLabel(segments: BeraReportSegmentDTO[]): string {
	const [firstSegment] = segments;

	if (segments.length === SINGLE_STRETCH && firstSegment) {
		return toStretchIntervalLabel(firstSegment);
	}

	const result = `${segments.length} ${I18n.get('identified stretches')}`;

	return result;
}
